import React, {useContext} from 'react';
import {Avatar, Image, Row, Col, Card} from 'antd';
import _ from 'lodash';
import {useAuthStore} from '@/context/auth';
import styles from './view.module.less';
import MsgContext from '@/page/customer/MsgPage/msgContext';
import dayjs from 'dayjs';
import ReactPlayer from 'react-player';

export default function View() {
    const {images, link, videos, viewText} = useContext(MsgContext);
    const [authStore] = useAuthStore();
    const name = _.get(authStore, 'user.name');
    const avatar = _.get(authStore, 'user.avatar');
    const month = dayjs().format('MM');
    const day = dayjs().format('DD');
    console.log(link, images, videos);
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.name}>{name}</div>
                <div className={styles.avatar}>
                    <Avatar
                        src={avatar}
                        style={{width: '60px', height: '60px', borderRadius: '5px'}}
                    />
                </div>
            </div>
            {(!_.isEmpty(link) ||
                images.length > 0 ||
                videos.length > 0 ||
                !_.isEmpty(viewText)) && (
                <div className={styles.content}>
                    <div className={styles.time}>
                        <span className={styles.day}>
                            {parseInt(day, 10) >= 10 ? day : '0' + day}
                        </span>
                        <span>{month + '月'}</span>
                    </div>
                    <div className={styles.moment}>
                        <span>{images.length == 0 && videos.length == 0 && viewText}</span>
                        {link && (
                            <div className={styles.link}>
                                <Image
                                    src={link.imageUrl}
                                    width={50}
                                    height={50}
                                    style={{objectFit: 'cover'}}
                                />
                                <div style={{marginLeft: '5px'}}>{link.title}</div>
                            </div>
                        )}
                        {images.length > 0 && (
                            <div className={styles.image}>
                                <Row className={styles.block}>
                                    {images.map(
                                        (item, i) =>
                                            i < 4 && (
                                                <Col span={12}>
                                                    <Image
                                                        key={i}
                                                        src={item.urls.file}
                                                        width={50}
                                                        height={50}
                                                        style={{objectFit: 'cover'}}
                                                    />
                                                </Col>
                                            )
                                    )}
                                </Row>
                                <div className={styles.value}>
                                    <div className={styles.title}>
                                        {viewText && viewText.length > 15
                                            ? viewText.substr(0, 15) + '...'
                                            : viewText}
                                    </div>
                                    <div className={styles.total}>
                                        {'共' + images.length + '张'}
                                    </div>
                                </div>
                            </div>
                        )}
                        {videos.length > 0 && (
                            <div className={styles.image}>
                                <div>
                                    <ReactPlayer
                                        controls
                                        playing={false}
                                        url={videos[0].urls.file}
                                        height={60}
                                        width={100}
                                    />
                                </div>
                                <div className={styles.value}>
                                    <div className={styles.title}>
                                        {viewText && viewText.length > 15
                                            ? viewText.substr(0, 15) + '...'
                                            : viewText}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
